//#region Old Code

// import React from 'react';
// import {browserHistory} from 'react-router';
// import request from 'arcdynamic-request';
// const buyerStateBreakdownRoute = '/buyer-state-breakdown';
// const transactionBreakdownRoute = '/transaction-breakdown';
// const marketTransactionBreakdownRoute = '/market-transaction-breakdown';
// const marketShareRoute = '/market-share';
// const listRoute = '/list';
// import {TERRITORIES} from "../../consts/tables";


// export default class Filter extends React.Component {
// 	constructor(props) {
// 		super(props);
// 		const query = {...this.props.location.query};

// 		this.state = {
// 			query,
// 			paneIndex: 0,
//             buyerStateBreakdownCheckbox: false,
//             transactionBreakdownCheckbox: false,
//             marketTransactionBreakdownCheckbox: false,
//             marketShareCheckbox: false,
//             isBreakdown: false,
//             territoryData: [],
//             cityListData:[],
//         };

// 		this.clear = this.clear.bind(this);
// 		this.close = this.close.bind(this);
// 		this.setValue = this.setValue.bind(this);
// 		this.handleChange = this.handleChange.bind(this);
// 		this.handleSubmit = this.handleSubmit.bind(this);
//         this.handleDropdownChange = this.handleDropdownChange.bind(this);
//         this.getValuesForDropdown = this.getValuesForDropdown.bind(this);
//         this.handleBreakdownChange = this.handleBreakdownChange.bind(this);
//         this.navigateTo = this.navigateTo.bind(this);
//         this.setTerriotryData = this.setTerriotryData.bind(this);
//         this.setCityListData = this.setCityListData.bind(this);
//         this.getCities = this.getCities.bind(this);
//         this.getTerritoryType = this.getTerritoryType.bind(this);
//         this.getTerritoryCategory = this.getTerritoryCategory.bind(this);
//     }
//     setTerriotryData(territoryData) {
//         this.setState(territoryData)
//     }
//     setCityListData(cityListData) {
//         this.setState(cityListData)
//     }   

//     static getDefaultQuery(page) {
// 		if (!page) {
// 			return {
//                 SOURCE: 'STRIVE',
//                 STATUS: 'Active',
// 				TRANSACTION_TYPE: 'Investment Sales'
// 			}
// 		}

//         const today = new Date();
//         const currentYear = today.getFullYear();
//         const currentMonth = today.getMonth()+1;
//         const currentDay = today.getDate();
//         const baseMin = `1/1/${currentYear}`;
//         const baseMax = `${currentMonth}/${currentDay}/${currentYear}`;
//         const comparisonMin = `1/1/${currentYear-1}`;
//         const comparisonMax = `${currentMonth}/${currentDay}/${currentYear-1}`;

//         switch (page) {
// 			case 'buyerStateBreakdown':
//                 return {
//                     SOURCE: 'STRIVE',
//                     STATUS: 'Closed',
//                     BASE_MIN: baseMin,
//                     BASE_MAX: baseMax,
//                     COMPARISON_MIN: comparisonMin,
//                     COMPARISON_MAX: comparisonMax,
// 				};
// 			case 'transactionBreakdown':
//                 return {
//                     STATE: 'TX',
//                     TYPE: 'STNL',
//                     STATUS: 'Closed',
// 					CATEGORY: 'retail',
//                     TRANSACTION_YEAR: currentYear,
//                 };
//             case 'marketTransactionBreakdown':
//                 return {
//                     STATE: 'TX',
//                     STATUS: 'Closed',
//                     CATEGORY: 'retail',
// 					MARKET: 'DFW',
//                     BASE_MIN: baseMin,
//                     BASE_MAX: baseMax,
//                     COMPARISON_MIN: comparisonMin,
//                     COMPARISON_MAX: comparisonMax,
//                 };
//             case 'marketShare':
//                 return {
//                     STATE: 'TX',
//                     STATUS: 'Closed',
//                     TRANSACTION_TYPE: 'Investment Sales',
// 					CATEGORY: 'retail',
// 					MARKET: 'DFW',
//                 };
//         }
//     }

// 	handleSubmit(e) {
// 		e.preventDefault();

// 		const query = {...this.state.query};
// 		const isBreakdown = this.state.isBreakdown;
//         const buyerStateBreakdownCheckbox = this.state.buyerStateBreakdownCheckbox;
//         const transactionBreakdownCheckbox = this.state.transactionBreakdownCheckbox;
//         const marketTransactionBreakdownCheckbox = this.state.marketTransactionBreakdownCheckbox;
//         const marketShareCheckbox = this.state.marketShareCheckbox;

// 		// Remove blank values
// 		Object.keys(query).forEach(key => {
// 			if (!query[key]) {
// 				delete query[key];
// 			}
//             // if(key==='TERRITORY_LISTING_AGENT_TEAM'){
//             //     delete query[key];
//             // }
// 		});

// 		window.scrollTo(0, 0);

// 		// if Buyer State, Transaction Breakdowns or Market Share are activated
//         if (buyerStateBreakdownCheckbox || transactionBreakdownCheckbox || marketTransactionBreakdownCheckbox || marketShareCheckbox) {
//             browserHistory.push({
//                 pathname: buyerStateBreakdownCheckbox ? buyerStateBreakdownRoute : transactionBreakdownCheckbox ? transactionBreakdownRoute : marketTransactionBreakdownCheckbox ? marketTransactionBreakdownRoute : marketShareRoute,
//                 query,
//             });
//             return;
//         }

//         // if Buyer State, Transaction Breakdowns or Market Share are deactivated
//         if (isBreakdown && (!buyerStateBreakdownCheckbox && !transactionBreakdownCheckbox && !marketTransactionBreakdownCheckbox && !marketShareCheckbox)) {
//             this.setState({isBreakdown: !isBreakdown});
//             browserHistory.push({
//                 pathname: listRoute,
//                 query,
//             });
//             return;
//         }

//         // if STATUS = 'Under Contract' sort properties desc by EFFECTIVE_DATE
//         if (query.STATUS === 'Under Contract')
//             query.order = 'EFFECTIVE_DATE.desc';
//         if (query.STATUS !== 'Under Contract' && query.order)
//             if (Array.isArray(query.order)) {
//                 const index = query.order.indexOf('EFFECTIVE_DATE.desc');
//                 if (index > -1) query.order.splice(index, 1);
//             } else delete query.order;


//         browserHistory.push({
// 			pathname: this.props.location.pathname,
// 			query,
// 		});
// 	}

// 	componentDidMount() {
// 		const isBuyerStateBreakdown = this.props.location.pathname === buyerStateBreakdownRoute;
//         const isTransactionBreakdown = this.props.location.pathname === transactionBreakdownRoute;
//         const isMarketTransactionBreakdown = this.props.location.pathname === marketTransactionBreakdownRoute;
//         const isMarketShare = this.props.location.pathname === marketShareRoute;
//         const isBreakdown = isBuyerStateBreakdown || isTransactionBreakdown || isMarketTransactionBreakdown || isMarketShare;
//         this.setState({
// 			isBreakdown,
// 			buyerStateBreakdownCheckbox: isBuyerStateBreakdown,
// 			transactionBreakdownCheckbox: isTransactionBreakdown,
//             marketTransactionBreakdownCheckbox: isMarketTransactionBreakdown,
//             marketShareCheckbox: isMarketShare,
//         });

//         try {

//         Promise.all([
//             request(arc.path.api, {
//                 service: 'arcimedes',
//                 action: 'open.datasource.table.Data.getData',
//                 params: ['code', TERRITORIES, {
//                     limit: {
//                         count: 1000,
//                         offset: 0,
//                     },
//                     column: [
//                         'ARCIMEDES_ROW_ID',
//                         'AGENT_NAME',
//                         'ZIP',
//                         'CITY',
//                         'MARKET',
//                         'TERRITORY_TYPE',
//                         'CATEGORY'
//                     ],
//                 }],
//             }), request(arc.path.api, {
//                 service: 'arcimedes',
//                 action: 'open.datasource.table.Data.getData',
//                 params: ['code', 'TEAM', {
//                     limit: {
//                         count: 1000,
//                         offset: 0,
//                     },
//                     column: [
//                         'ARCIMEDES_ROW_ID',
//                         'FIRST_NAME',
//                         'LAST_NAME',
//                         'DELETED',
//                     ],
//                     filter: [
//                         {
//                             code: 'FIRST_NAME',
//                             text: '',
//                             type: 'notNull',
//                         },
//                         {
//                             code: 'LAST_NAME',
//                             text: '',
//                             type: 'notNull',
//                         },
//                     ],
//                     filterType: 'and',
//                     order: [
//                         {
//                             code: 'FIRST_NAME',
//                             type: 'asc',
//                         },
//                         {
//                             code: 'LAST_NAME',
//                             type: 'asc',
//                         },
//                     ],
//                 }],
//             }),
//             request(arc.path.api, {
//                 service: 'arcimedes',
//                 action: 'open.datasource.table.Data.getData',
//                 params: ['code', TERRITORIES, {
//                     limit: {
//                         count: 1000,
//                         offset: 1000,
//                     },
//                     column: [
//                         'ARCIMEDES_ROW_ID',
//                         'AGENT_NAME',
//                         'ZIP',
//                         'CITY',
//                         'MARKET',
//                         'TERRITORY_TYPE',
//                         'CATEGORY'
//                     ],
//                 }],
//             }),
//             request(arc.path.api, {
//                 service: 'arcimedes',
//                 action: 'open.datasource.table.Data.getData',
//                 params: ['code', TERRITORIES, {
//                     limit: {
//                         count: 1000,
//                         offset: 2000,
//                     },
//                     column: [
//                         'ARCIMEDES_ROW_ID',
//                         'AGENT_NAME',
//                         'ZIP',
//                         'CITY',
//                         'MARKET',
//                         'TERRITORY_TYPE',
//                         'CATEGORY'
//                     ],
//                 }],
//             })]).then((res) => {
//                 let dataset1 = res[0].data ? res[0].data : false;
//                 let dataset2 = res[2].data ? res[2].data : false;
//                 let dataset3 = res[3].data ? res[3].data : false;
//                 let responseData = [...dataset1, ...dataset2,...dataset3];
//                 for(let property of responseData) {
//                     property['TYPE'] = property['TERRITORY_TYPE'];
//                     delete property['TERRITORY_TYPE'];
//                 }
//                 let territoryDataItems = responseData ? responseData.filter(x => x.AGENT_NAME) : false;
//                 let cityListData = responseData ? responseData : false;              
//                 const itemsList = [];

//                 this.setState({
//                     cityListData: cityListData,
//                     territoryData: territoryDataItems,
//                     items: territoryDataItems
//                 });
//             })

//         } catch (e) {
//             console.log("error occured", e);
//         }

//     }

// 	componentWillReceiveProps(nextProps) {
// 		if (this.props.location.query !== nextProps.location.query) {
//             const isBuyerStateBreakdown = nextProps.location.pathname === buyerStateBreakdownRoute;
//             const isTransactionBreakdown = nextProps.location.pathname === transactionBreakdownRoute;
//             const isMarketTransactionBreakdown = nextProps.location.pathname === marketTransactionBreakdownRoute;
//             const isMarketShare = nextProps.location.pathname === marketShareRoute;
//             const isBreakdown = isBuyerStateBreakdown || isTransactionBreakdown || isMarketTransactionBreakdown || isMarketShare;
//             const query = {...nextProps.location.query};
// 			delete query.page;
// 			this.setState({
// 				query,
// 				isBreakdown,
// 				buyerStateBreakdownCheckbox: isBuyerStateBreakdown,
//                 transactionBreakdownCheckbox: isTransactionBreakdown,
//                 marketTransactionBreakdownCheckbox: isMarketTransactionBreakdown,
//                 marketShareCheckbox: isMarketShare,
//             });
//         }
//     }
//     getTerritoryType(query, previousQuery, items){        
//         const _items =  items && items.find((e)=> e.ARCIMEDES_ROW_ID===query.TERRITORY_LISTING_AGENT_TEAM) || {};
//         const  _query={...query,TYPE:_items.TYPE || query.TYPE}
//         if(JSON.stringify(_query)!==JSON.stringify(query)){
//             this.handleDropdownChange(_query)             
//         }
//         if (query.CATEGORY != 'retail') return '';
//         return _items.TYPE || query.TYPE;
//     }

//     getTerritoryCategory(query, previousQuery, items){        
//         const _items =  items && items.find((e)=> e.ARCIMEDES_ROW_ID===query.TERRITORY_LISTING_AGENT_TEAM) || {};
//         const  _query={...query,CATEGORY:_items.CATEGORY || query.CATEGORY}
//         if(JSON.stringify(_query)!==JSON.stringify(query)){
//             this.handleDropdownChange(_query)             
//         }
//         return _items.CATEGORY || query.CATEGORY;
//     }

//     getCities(query, previousQuery){
//         if(this.state && this.state.items){
//             const agent = this.state.items.find((e)=> e.ARCIMEDES_ROW_ID === query.TERRITORY_LISTING_AGENT_TEAM);
//             const cityList = agent ? this.state.cityListData.filter((e)=> e.AGENT_NAME === agent.AGENT_NAME) : this.state.cityListData;
//             const compareByCity = (a, b) => a.CITY === b.CITY;
//             const compareByZIP = (a, b) => a.ZIP === b.ZIP;
//             const dataMTNLCities = cityList.filter(
//                 (item, index, self) => self.findIndex((i) => compareByCity(i, item)) === index
//             );
//             let _query ={ ...query}
//             if(query.TERRITORY_LISTING_AGENT_TEAM!= undefined ){
//                 const category = query.CATEGORY
//                 const cityByZip = cityList.filter(
//                     (item, index, self) => self.findIndex((i) => compareByZIP(i, item)) === index
//                 );

//                 let cityString = dataMTNLCities.map((e) => e.CITY).join();
//                 let zipString = cityByZip.map((e) => e.ZIP).join();
//                 let marketString = dataMTNLCities.map((e) => e.MARKET).join();
//                 _query ={ ...query,CITY:cityString, ZIP:zipString, MARKET:marketString,SOURCE:'', CATEGORY:category}
//             }           
//             if(JSON.stringify(_query)!==JSON.stringify(query)){
//                 this.handleDropdownChange(_query)             
//             }


//             return dataMTNLCities;    
//         }
//         return this.state.cityListData;
//     }

//     clear() {
//         window.scrollTo(0, 0);
//         if (!this.props.isSuper && this.props.location.pathname === '/buyers') {
//             browserHistory.push(`${arc.path.base}buyers?STATUS=1031-Buyer%2CActive`)
//         } else {
//             browserHistory.push(this.props.location.pathname);
//         }
//     }
//     handleDropdownChange(query, optionType, value, valueKey, typeKey, reason, previousQuery) {
//         const transactionBreakdown = this.state.transactionBreakdownCheckbox;


//         if (valueKey === 'TYPE') {
//             delete query.SINGLE_TENANT_SUBCATEGORY;
//             delete query.MULTI_TENANT_SUBCATEGORY;
//             delete query.TENANT_ID;
//             delete query.LEASE_TYPE;
//         }

//         if (valueKey === 'TYPE' && transactionBreakdown) {
//             if (query.TYPE === 'MT') {
//                 query.SOLD_PRICE_MIN = 400000;
//                 query.SQFT_MIN = 5000;
//             } else {
//                 delete query.SOLD_PRICE_MIN;
//                 delete query.SOLD_PRICE_MAX;
//                 delete query.SQFT_MIN;
//                 delete query.SQFT_MAX;
//             }
//         }

//         if (valueKey === 'SOURCE' && query[valueKey] === 'HSC') {
//             query.HSC_STATUS = 'Courting,Loan In Process';
//             delete query.STATUS;
//             delete query.TRANSACTION_TYPE;
//         }

//         if (valueKey === 'SOURCE' && query[valueKey] !== 'HSC') {
//             delete query.HSC_STATUS;
//         }

//         this.setState({ previousQuery:previousQuery, query });
//     }

//     handleChange(key, value) {
//         const q = {
//             [key]: value
//         };

//         if (key === 'TYPE') {
//             q.SINGLE_TENANT_SUBCATEGORY = null;
//             q.MULTI_TENANT_SUBCATEGORY = null;
//             q.TENANT_ID = null;
//             q.LEASE_TYPE = null;
//         }

//         this.setState({
//             query: Object.assign(this.state.query, q),
//         });
//     }

//     handleBreakdownChange(name) {
//         const breakdownCheckbox = !this.state[name];
//         let page = null;
//         let query;

//         switch (name) {
// 			case 'buyerStateBreakdownCheckbox':
// 				page = breakdownCheckbox ? 'buyerStateBreakdown' : null;
// 				query = Filter.getDefaultQuery(page);
// 				this.setState({query, buyerStateBreakdownCheckbox: breakdownCheckbox});
// 				break;
//             case 'transactionBreakdownCheckbox':
//                 page = breakdownCheckbox ? 'transactionBreakdown' : null;
//                 query = Filter.getDefaultQuery(page);
//                 this.setState({query, transactionBreakdownCheckbox: breakdownCheckbox});
//                 break;
//             case 'marketTransactionBreakdownCheckbox':
//                 page = breakdownCheckbox ? 'marketTransactionBreakdown' : null;
//                 query = Filter.getDefaultQuery(page);
//                 this.setState({query, marketTransactionBreakdownCheckbox: breakdownCheckbox});
//                 break;
//             case 'marketShareCheckbox':
//                 page = breakdownCheckbox ? 'marketShare' : null;
//                 query = Filter.getDefaultQuery(page);
//                 this.setState({query, marketShareCheckbox: breakdownCheckbox});
//                 break;
// 		}
//     }

// 	setValue(updates) {
// 		this.setState({query: {...this.state.query, ...updates}});
// 	}

// 	close() {
// 		this.refs.searchPanel.close();
// 	}

// 	getValuesForDropdown(query, options, key, type='multiple') {
// 		if (!query || !options || query.length === 0 ) {
// 			return [];
//         }

// 		let formattedQueryValues = query.split(',');
// 		let response = [];
// 		options.forEach((el) => {
// 			if (!key) {
// 				if (formattedQueryValues.includes(el)) {
// 					response.push(el)
// 				}
// 			} else {
// 				if (formattedQueryValues.includes(el[key])) {
// 					response.push(el)
// 				}
// 			}
// 		});

// 		if (!response) {
// 			return [];
//         }
// 		if (type === "multiple") {
// 			return response;
// 		}
// 		return response[0] ? response[0] : null;
// 	}

//     navigateTo(pathname) {
//         const {isBreakdown, query} = this.state;
//         if (isBreakdown) {
//             const q = Filter.getDefaultQuery();
//             this.setState({
// 				query: q,
// 				isBreakdown: !isBreakdown,
// 				buyerStateBreakdownCheckbox: false,
// 				transactionBreakdownCheckbox: false,
//                 marketTransactionBreakdownCheckbox: false,
//                 marketShareCheckbox: false,
//             });
//             browserHistory.push({
//                 pathname,
//                 query: q,
//             });
//             return;
//         }

//         browserHistory.push({
//             pathname: pathname,
//             query,
//         });
// 	}
// }
//#endregion


//#region New Code
import React from 'react';
import { browserHistory } from 'react-router';
import request from 'arcdynamic-request';
const buyerStateBreakdownRoute = '/buyer-state-breakdown';
const transactionBreakdownRoute = '/transaction-breakdown';
const marketTransactionBreakdownRoute = '/market-transaction-breakdown';
const marketShareRoute = '/market-share';
const listRoute = '/list';
import { TERRITORIES } from "../../consts/tables";
import { GET_TEAM, GET_TERRITORIES, GET_TERRITORY_AGENTS } from '../Graphql/Queries/FilterQuery';
import { GET_CONTACT_TEAM_LIST_QUERY } from '../Graphql/ContactsQueries/contactsQuery';
import { fetchData } from '../Service/graphQlService';

const SUPER_USER_QUERY_KEYS = ['modified_by', 'created_by'];

function normalizeSuperUserQueryCaseForUi(locationQuery) {
    if (!locationQuery || typeof locationQuery !== 'object') return locationQuery;
    const query = { ...locationQuery };
    SUPER_USER_QUERY_KEYS.forEach((k) => {
        const v = query[k];
        if (v != null && String(v).toLowerCase() === 'auto') {
            query[k] = 'Auto';
        }
    });
    return query;
}

function normalizeSuperUserQueryForUrl(query) {
    if (!query || typeof query !== 'object') return query;
    const next = { ...query };
    SUPER_USER_QUERY_KEYS.forEach((k) => {
        const v = next[k];
        if (v != null && String(v).toLowerCase() === 'auto') {
            next[k] = 'AUTO';
        }
    });
    return next;
}

export default class Filter extends React.Component {
    constructor(props) {
        super(props);
        const query = normalizeSuperUserQueryCaseForUi({ ...this.props.location.query });

        this.state = {
            query,
            paneIndex: 0,
            buyerStateBreakdownCheckbox: false,
            transactionBreakdownCheckbox: false,
            marketTransactionBreakdownCheckbox: false,
            marketShareCheckbox: false,
            isBreakdown: false,
            territoryData: [],
            cityListData: [],
            isClearFilter:false
        };
        this.client = null;
        this.clear = this.clear.bind(this);
        this.close = this.close.bind(this);
        this.setValue = this.setValue.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.getValuesForDropdown = this.getValuesForDropdown.bind(this);
        this.handleBreakdownChange = this.handleBreakdownChange.bind(this);
        this.navigateTo = this.navigateTo.bind(this);
    }

    static getDefaultQuery(page) {
        if (!page) {
            return {
                SOURCE: 'STRIVE',
                STATUS: 'Active',
                TRANSACTION_TYPE: 'Investment Sales'
            }
        }

        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth() + 1;
        const currentDay = today.getDate();
        const baseMin = `1/1/${currentYear}`;
        const baseMax = `${currentMonth}/${currentDay}/${currentYear}`;
        const comparisonMin = `1/1/${currentYear - 1}`;
        const comparisonMax = `${currentMonth}/${currentDay}/${currentYear - 1}`;

        switch (page) {
            case 'buyerStateBreakdown':
                return {
                    source: 'STRIVE',
                    status: 'Closed',
                    base_min: baseMin,
                    base_max: baseMax,
                    comparison_min: comparisonMin,
                    comparison_max: comparisonMax,
                };
            case 'transactionBreakdown':
                return {
                    state: 'TX',
                    type: 'STNL',
                    status: 'Closed',
                    category: 'retail',
                    transaction_year: currentYear,
                };
            case 'marketTransactionBreakdown':
                return {
                    state: 'TX',
                    status: 'Closed',
                    category: 'retail',
                    market: 'DFW',
                    base_min: baseMin,
                    base_max: baseMax,
                    comparison_min: comparisonMin,
                    comparison_max: comparisonMax,
                };
            case 'marketShare':
                return {
                    state: 'TX',
                    status: 'Closed',
                    transaction_type: 'Investment Sales',
                    category: 'retail',
                    market: 'DFW',
                };
        }
    }

    handleSubmit(e) {
        e.preventDefault();

        const query = { ...this.state.query };
        const isBreakdown = this.state.isBreakdown;
        const buyerStateBreakdownCheckbox = this.state.buyerStateBreakdownCheckbox;
        const transactionBreakdownCheckbox = this.state.transactionBreakdownCheckbox;
        const marketTransactionBreakdownCheckbox = this.state.marketTransactionBreakdownCheckbox;
        const marketShareCheckbox = this.state.marketShareCheckbox;

        // Remove blank values
        Object.keys(query).forEach(key => {
            if (!query[key]) {
                delete query[key];
            }
            // if(key==='TERRITORY_LISTING_AGENT_TEAM'){
            //     delete query[key];
            // }
        });

        window.scrollTo(0, 0);

        // if Buyer State, Transaction Breakdowns or Market Share are activated
        if (buyerStateBreakdownCheckbox || transactionBreakdownCheckbox || marketTransactionBreakdownCheckbox || marketShareCheckbox) {
            browserHistory.push({
                pathname: buyerStateBreakdownCheckbox ? buyerStateBreakdownRoute : transactionBreakdownCheckbox ? transactionBreakdownRoute : marketTransactionBreakdownCheckbox ? marketTransactionBreakdownRoute : marketShareRoute,
                query: normalizeSuperUserQueryForUrl(query),
            });
            return;
        }

        // if Buyer State, Transaction Breakdowns or Market Share are deactivated
        if (isBreakdown && (!buyerStateBreakdownCheckbox && !transactionBreakdownCheckbox && !marketTransactionBreakdownCheckbox && !marketShareCheckbox)) {
            this.setState({ isBreakdown: !isBreakdown });
            browserHistory.push({
                pathname: listRoute,
                query: normalizeSuperUserQueryForUrl(query),
            });
            return;
        }

        // if STATUS = 'Under Contract' sort properties desc by EFFECTIVE_DATE
        if (query.status === 'Under Contract')
            query.order = 'EFFECTIVE_DATE.desc';
        if (query.status !== 'Under Contract' && query.order)
            if (Array.isArray(query.order)) {
                const index = query.order.indexOf('EFFECTIVE_DATE.desc');
                if (index > -1) query.order.splice(index, 1);
            } else delete query.order;


        browserHistory.push({
            pathname: this.props.location.pathname,
            query: normalizeSuperUserQueryForUrl(query),
        });
    }

    componentDidMount() {
        const isBuyerStateBreakdown = this.props.location.pathname === buyerStateBreakdownRoute;
        const isTransactionBreakdown = this.props.location.pathname === transactionBreakdownRoute;
        const isMarketTransactionBreakdown = this.props.location.pathname === marketTransactionBreakdownRoute;
        const isMarketShare = this.props.location.pathname === marketShareRoute;
        const isBreakdown = isBuyerStateBreakdown || isTransactionBreakdown || isMarketTransactionBreakdown || isMarketShare;
        this.setState({
            isBreakdown,
            buyerStateBreakdownCheckbox: isBuyerStateBreakdown,
            transactionBreakdownCheckbox: isTransactionBreakdown,
            marketTransactionBreakdownCheckbox: isMarketTransactionBreakdown,
            marketShareCheckbox: isMarketShare,
        });

        // const { client } = this;
        // if (!client) return;
        try {
            
            fetchData(GET_TERRITORY_AGENTS,).then((res) => {
                if(res && res.data && res.data.territoryAgentMapping && res.data.territoryAgentMapping.success){
                    let responseData = res.data.territoryAgentMapping.data;
                    for(let property of responseData) {
                        property['agent_name'] = property['first_name']+' '+property['last_name'];
                        delete property['first_name'];
                        delete property['last_name'];
                    }
                    responseData = responseData.reduce((acc, curr) => {
                        const agent = acc.find(agent => agent.agent_id === curr.agent_id);
                        
                        if (agent) {
                            // If AGENT_ID already exists, concatenate the MARKET with a comma, avoiding duplicates
                            if (!agent.territory_market.includes(curr.market)) {
                                agent.territory_market += `,${curr.market}`;
                            }
                            if (!agent.product_type.includes(curr.product_type)) {
                                agent.product_type += `,${curr.product_type}`;
                            }
                            if (!agent.territory.toString().includes(curr.territory)) {
                                agent.territory += `,${curr.territory}`;
                            }
                            agent.combinations.push({
                                territory_market: curr.market,
                                product_type: curr.product_type,
                                territory: curr.territory,
                            });
                        } else {
                            // If AGENT_ID doesn't exist, create a new entry with MARKET as a string
                            acc.push({
                                ...curr,
                                territory_market: curr.market,
                                product_type: curr.product_type,
                                territory: curr.territory,
                                combinations: [{
                                    territory_market: curr.market,
                                    product_type: curr.product_type,
                                    territory: curr.territory,
                                }]
                            });
                        }
                        
                        return acc;
                    }, []);
                    let territoryDataItems = responseData ? responseData.filter(x => x.agent_name) : false;
                    this.setState({
                        items: territoryDataItems
                    });
                    if(this.props.location.pathname === "/list"){
                        let paneIndex = Number(sessionStorage.getItem('lastClickedFilter'))?Number(sessionStorage.getItem('lastClickedFilter')):0;
                        this.setState({paneIndex})
                    }
                }
                })
    
            } catch (e) {
                console.log("error occured", e);
            }
    

    }

    componentWillReceiveProps(nextProps) {
        if (this.props.location.query !== nextProps.location.query) {
            const isBuyerStateBreakdown = nextProps.location.pathname === buyerStateBreakdownRoute;
            const isTransactionBreakdown = nextProps.location.pathname === transactionBreakdownRoute;
            const isMarketTransactionBreakdown = nextProps.location.pathname === marketTransactionBreakdownRoute;
            const isMarketShare = nextProps.location.pathname === marketShareRoute;
            const isBreakdown = isBuyerStateBreakdown || isTransactionBreakdown || isMarketTransactionBreakdown || isMarketShare;
            const query = normalizeSuperUserQueryCaseForUi({ ...nextProps.location.query });
            delete query.page;
            this.setState({
                query,
                isBreakdown,
                buyerStateBreakdownCheckbox: isBuyerStateBreakdown,
                transactionBreakdownCheckbox: isTransactionBreakdown,
                marketTransactionBreakdownCheckbox: isMarketTransactionBreakdown,
                marketShareCheckbox: isMarketShare,
            });
        }
    }
    //i added from old code, for territories in property filter
   

    clear() {
    this.setState(() => ({
         isClearFilter: true,
      }));
     setTimeout(() => {
       this.setState({ isClearFilter: false });
     }, 2000);
        window.scrollTo(0, 0);
        if (!this.props.isSuper && this.props.location.pathname === '/buyers') {
            browserHistory.push(`${arc.path.base}buyers?STATUS=1031-Buyer%2CActive`)
        } else {
            browserHistory.push(this.props.location.pathname);
        }
    }
    handleDropdownChange(query, optionType, value, valueKey, typeKey, reason, previousQuery) {
        const transactionBreakdown = this.state.transactionBreakdownCheckbox;


        if (valueKey === 'type') {
            delete query.single_tenant_subcategory;
            delete query.multi_tenant_subcategory;
            delete query.tenant_id;
            delete query.lease_type;
        }

        if (valueKey === 'type' && transactionBreakdown) {
            if (query.type === 'MT') {
                query.sold_price_min = 400000;
                query.sqft_min = 5000;
            } else {
                delete query.sold_price_min;
                delete query.sold_price_max;
                delete query.sqft_min;
                delete query.sqft_max;
            }
        }

        if (valueKey === 'source' && query[valueKey] === 'HSC') {
            query.hsc_status = 'Courting,Loan In Process';
            delete query.status;
            delete query.transaction_type;
        }

        if (valueKey === 'source' && query[valueKey] !== 'HSC') {
            delete query.hsc_status;
        }
        if(valueKey === 'territory_listing_agent_team' && reason === null){
            if(!query.hasOwnProperty('territory_listing_agent_team')){
                const toRemove = ["product_type", "territory_market", "territory"];
                Object.keys(query).forEach(key => {
                    if (toRemove.some(base => key.startsWith(base))) {
                    delete query[key];
                    }
                });
            }
        }else if(valueKey === 'territory_listing_agent_team'){
            reason['combinations'].map((item, idx) => {
                query = {
                    ...query,
                    [`product_type_${idx+1}`]: item.product_type,
                    [`territory_market_${idx+1}`]: item.territory_market,
                    [`territory_${idx+1}`]: item.territory,
                }
            })
        }
        if(valueKey.startsWith("product_type") && reason === null){
            const number = valueKey.match(/\d+/);
            query[`territory_market_${number}`] = ''
            query[`territory_${number}`] = ''
        }else if(valueKey.startsWith("territory_market") && reason === null){
            const number = valueKey.match(/\d+/);
            query[`territory_${number}`] = ''
        }
        if(this.state.paneIndex === 4){
            if (valueKey === 'status' && !(query.status.includes('Active'))){
                if(query.listed_date_min){
                    delete query.listed_date_min
                }
                if(query.listed_date_max){
                    delete query.listed_date_max
                }
            }
            if(valueKey === 'status' && !(query.status.includes('Closed'))){
                if(query.close_of_escrow_min){
                    delete query.close_of_escrow_min
                }
                if(query.close_of_escrow_max){
                    delete query.close_of_escrow_max
                }
            }
        }
        this.setState({ previousQuery: previousQuery, query });
    }

    handleChange(key, value) {
        const q = {
            [key]: value
        };

        if (key === 'type') {
            q.single_tenant_subcategory = null;
            q.multi_tenant_subcategory = null;
            q.tenant_id = null;
            q.lease_type = null;
        }
        this.setState({
            query: Object.assign(this.state.query, q),
        });
    }

    handleBreakdownChange(name) {
        const breakdownCheckbox = !this.state[name];
        let page = null;
        let query;

        switch (name) {
            case 'buyerStateBreakdownCheckbox':
                page = breakdownCheckbox ? 'buyerStateBreakdown' : null;
                query = Filter.getDefaultQuery(page);
                this.setState({ query, buyerStateBreakdownCheckbox: breakdownCheckbox });
                break;
            case 'transactionBreakdownCheckbox':
                page = breakdownCheckbox ? 'transactionBreakdown' : null;
                query = Filter.getDefaultQuery(page);
                this.setState({ query, transactionBreakdownCheckbox: breakdownCheckbox });
                break;
            case 'marketTransactionBreakdownCheckbox':
                page = breakdownCheckbox ? 'marketTransactionBreakdown' : null;
                query = Filter.getDefaultQuery(page);
                this.setState({ query, marketTransactionBreakdownCheckbox: breakdownCheckbox });
                break;
            case 'marketShareCheckbox':
                page = breakdownCheckbox ? 'marketShare' : null;
                query = Filter.getDefaultQuery(page);
                this.setState({ query, marketShareCheckbox: breakdownCheckbox });
                break;
        }
    }

    setValue(updates) {
        this.setState({ query: { ...this.state.query, ...updates } });
    }

    close() {
        this.refs.searchPanel.close();
    }

    getValuesForDropdown(query, options, key, type = 'multiple') {
        if (!query || !options || query.length === 0) {
            return [];
        }

        let formattedQueryValues = query.split(',');
        let response = [];
        options.forEach((el) => {
            if (!key) {
                if (formattedQueryValues.includes(el)) {
                    response.push(el)
                }
            } else {
                if (formattedQueryValues.includes(el[key])) {
                    response.push(el)
                }
            }
        });

        if (!response) {
            return [];
        }
        if (type === "multiple") {
            return response;
        }
        return response[0] ? response[0] : null;
    }

    navigateTo(pathname) {
        const { isBreakdown, query } = this.state;
        if (isBreakdown) {
            const q = Filter.getDefaultQuery();
            this.setState({
                query: q,
                isBreakdown: !isBreakdown,
                buyerStateBreakdownCheckbox: false,
                transactionBreakdownCheckbox: false,
                marketTransactionBreakdownCheckbox: false,
                marketShareCheckbox: false,
            });
            browserHistory.push({
                pathname,
                query: q,
            });
            return;
        }

        browserHistory.push({
            pathname: pathname,
            query: normalizeSuperUserQueryForUrl(query),
        });
    }
    handlePaneChange(key){
        let {query, paneIndex} = this.state

        if(paneIndex === 4){
            delete query.territory_listing_agent_team
            delete query.territory
            delete query.product_type
            delete query.territory_market
            browserHistory.push({
                pathname: this.props.location.pathname,
                query: normalizeSuperUserQueryForUrl(query),
            });
        }
        this.setState({paneIndex: key})
        sessionStorage.setItem('lastClickedFilter', key);
    }
}
//#endregion